let picker;

export async function initCalendar() {
    try {

        // =====================================================
        // 1. OBTENER FECHAS BLOQUEADAS DESDE EL ENDPOINT
        // =====================================================

        const response = await fetch(
            'https://my-first-dive.com/Index/check_services_calendario'
        );

        const data = await response.json();

        // Fechas que ya están ocupadas/reservadas
        const disabledDates = data.booked_dates || [];


        // =====================================================
        // 2. INICIALIZAR LITEPICKER
        // =====================================================

        picker = new Litepicker({

            element: document.getElementById('calendar-container'),

            format: 'YYYY-MM-DD',

            lang: 'es',

            // No permitir fechas anteriores a hoy
            minDate: new Date(),

            singleMode: true,

            autoApply: true,

            inlineMode: true,


            // =================================================
            // 3. BLOQUEAR DÍAS
            // =================================================
            //
            // SOLO SE PERMITEN:
            //
            // MIÉRCOLES = 3
            // VIERNES   = 5
            //
            // JavaScript:
            //
            // Domingo     = 0
            // Lunes       = 1
            // Martes      = 2
            // Miércoles   = 3
            // Jueves      = 4
            // Viernes     = 5
            // Sábado      = 6
            //
            // =================================================

            lockDaysFilter: (date) => {

                const dayOfWeek = date.getDay();

                const dateString = date.format('YYYY-MM-DD');


                // ---------------------------------------------
                // ¿Es miércoles o viernes?
                // ---------------------------------------------

                const isAvailableDay =
                    dayOfWeek === 3 ||
                    dayOfWeek === 5;


                // ---------------------------------------------
                // Si NO es miércoles o viernes
                // → BLOQUEAR
                // ---------------------------------------------

                if (!isAvailableDay) {
                    return true;
                }


                // ---------------------------------------------
                // Si es miércoles o viernes pero ya está reservado
                // → BLOQUEAR
                // ---------------------------------------------

                if (disabledDates.includes(dateString)) {
                    return true;
                }


                // ---------------------------------------------
                // Miércoles/viernes disponibles
                // → PERMITIR
                // ---------------------------------------------

                return false;
            },


            // =================================================
            // 4. EVENTO CUANDO EL USUARIO SELECCIONA FECHA
            // =================================================

            setup: (picker) => {

                picker.on('selected', (date) => {

                    const fechaSeleccionada =
                        date.format('YYYY-MM-DD');


                    // Guardar fecha en el input oculto
                    document.getElementById('fecha').value =
                        fechaSeleccionada;


                    console.log(
                        'Fecha seleccionada:',
                        fechaSeleccionada
                    );


                    if (typeof window.updateResumenSeleccion === 'function') {
                        window.updateResumenSeleccion();
                    }
                });
            }
        });


    } catch (error) {

        console.error(
            'Error al cargar calendario:',
            error
        );

        // Si falla la consulta al servidor,
        // inicializamos el calendario igualmente
        initCalendarFallback();
    }
}



// =========================================================
// FALLBACK
// =========================================================
//
// Si el endpoint no responde:
//
// - Lunes     → bloqueado
// - Martes    → bloqueado
// - Miércoles → disponible
// - Jueves    → bloqueado
// - Viernes   → disponible
// - Sábado    → bloqueado
// - Domingo   → bloqueado
//
// =========================================================

function initCalendarFallback() {

    picker = new Litepicker({

        element: document.getElementById('calendar-container'),

        format: 'YYYY-MM-DD',

        lang: 'es',

        minDate: new Date(),

        singleMode: true,

        autoApply: true,

        inlineMode: true,


        // ---------------------------------------------
        // SOLO MIÉRCOLES Y VIERNES
        // ---------------------------------------------

        lockDaysFilter: (date) => {

            const dayOfWeek = date.getDay();

            const isAvailableDay =
                dayOfWeek === 3 ||
                dayOfWeek === 5;


            // Bloquear todos los días
            // excepto miércoles y viernes
            return !isAvailableDay;
        },


        // ---------------------------------------------
        // FECHA SELECCIONADA
        // ---------------------------------------------

        setup: (picker) => {

            picker.on('selected', (date) => {

                const fechaSeleccionada =
                    date.format('YYYY-MM-DD');


                document.getElementById('fecha').value =
                    fechaSeleccionada;


                console.log(
                    'Fecha seleccionada:',
                    fechaSeleccionada
                );


                if (typeof window.updateResumenSeleccion === 'function') {
                    window.updateResumenSeleccion();
                }
            });
        }
    });
}